<template>
    <settings-page
        :show="show"
        class="show-settings-add-ons"
    >
        <hosting-add-on
            :show="show"
        />

        <coming-soon-add-on />
    </settings-page>
</template>
<script>
import ComingSoonAddOn from '@/components/Shows/Settings/ComingSoonAddOn';
import HostingAddOn from '@/components/Shows/Settings/HostingAddOn';
import SettingsPage from './SettingsPage';

export default {
    components: {
        ComingSoonAddOn,
        HostingAddOn,
        SettingsPage,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },
};
</script>
